const sizeXXS = 380
const sizeXS = 768
const sizeSM = 992
const sizeMD = 1300
const sizeLG = Infinity

export { sizeXXS, sizeXS, sizeSM, sizeMD, sizeLG }
